<template>
  <div class="salaryview">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Payslip</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Payslip</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-white" @click="exportToPdf">
                    PDF
                  </button>
                  <button class="btn btn-white" v-print="printObj">
                    <i class="fa fa-print fa-lg"></i> Print
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card" id="printMe">
                <div class="card-body" ref="document">
                  <div style="display: flex; flex-wrap: wrap;">
                    <div
                      class="text-center"
                      style="
                        -webkit-box-flex: 0;
                        flex: 0 0 16.666667%;
                        max-width: 16.666667%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                      "
                    >
                      <img
                        :src="logo"
                        v-if="logo"
                        style="
                          max-height: 100px;
                          height: auto;
                          width: auto;
                          margin-bottom: 20px;
                        "
                        alt="Sapphire HR"
                      /><img
                        src="../../assets/logo2.png"
                        v-if="!logo"
                        class="inv-logo"
                        alt=""
                      />
                    </div>
                    <div
                      class="text-center"
                      style="
                        -webkit-box-flex: 0;
                        flex: 0 0 66.666667%;
                        max-width: 66.666667%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                      "
                    >
                      <h1
                        style="font-weight: 700 !
                      ; font-size: 3em;"
                      >
                        {{ company.name }}
                      </h1>
                      <h4>
                        Pay Advice for the Month of
                        {{ salary.data.periodMonth }},
                        {{ salary.data.periodYear }}
                      </h4>
                    </div>
                    <div
                      style="
                        -webkit-box-flex: 0;
                        flex: 0 0 16.666667%;
                        max-width: 16.666667%;
                        position: relative;
                        width: 100%;
                        padding-right: 15px;
                        padding-left: 15px;
                      "
                    ></div>
                  </div>
                  <div style="display: flex; flex-wrap: wrap; margin-bottom: 5px !important;">
                    <div
                      style="
                        border: 1px solid #ddd;
                        margin-right: 1% !important;
                        margin-left: 0 !important;
                        max-width: 49.5%;
                        flex: 0 0 50%;
                      "
                    >
                      <h3>Employee Details</h3>
                      <div style="display: flex; flex-wrap: wrap; margin-bottom: 5px !important;">
                        <div style="flex: 0 0 100%;">
                          <table>
                            <tbody>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Name:
                                  {{
                                    salary.employee.firstName +
                                      " " +
                                      salary.employee.lastName
                                  }}
                                </td>
                                <!-- <td style="margin-left: 1px !important">
                                  {{
                                    salary.employee.firstName +
                                      " " +
                                      salary.employee.lastName
                                  }}
                                </td> -->
                              </tr>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Department:
                                  {{
                                    salary.employee.designation.department
                                      ? salary.employee.designation.department
                                          .name
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <!-- <tr style="margin-bottom: 0 !important">
                                <td>Unit:</td>
                                <td style="margin-left: 3px !important">
                                  &nbsp;&nbsp;&nbsp;
                                </td>
                              </tr> -->
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Designation:
                                  {{ salary.employee.designation.name }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div style="flex: 0 0 100%;">
                          <table>
                            <tbody>
                              <tr>
                                <td>
                                  Staff Number:
                                  {{ salary.employee.employeeCode }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div
                      style="
                        margin-right: 0 !important;
                        margin-left: 0 !important;
                        max-width: 49.5%;
                        flex: 0 0 50%;
                      "
                    >
                      <div style="display: flex; flex-wrap: wrap;">
                        <div style="border: 1px solid #ddd; flex: 0 0 100%;">
                          <h3>Bank Details</h3>
                          <table>
                            <tbody>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Bank Account No:
                                  {{
                                    salary.employee.employeeBank
                                      ? salary.employee.employeeBank
                                          .bankAccountNumber
                                      : "&nbsp;&nbsp;&nbsp;"
                                  }}
                                </td>
                              </tr>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Bank Name:
                                  {{ salary.employee.employeeBank.bankName }}
                                </td>
                              </tr>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  Bank Sort Code:
                                  {{ salary.employee.employeeBank.bankCode }}
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div style="display: flex; flex-wrap: wrap;">
                        <div style="border: 1px solid #ddd; flex: 0 0 100%;">
                          <h3>Pension Details</h3>
                          <table>
                            <tbody>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  PFA Name:
                                  {{
                                    salary.employee.employeePension
                                      ? salary.employee.employeePension
                                          .pensionManager
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <tr style="margin-bottom: 0 !important">
                                <td>
                                  PFA Pin:
                                  {{
                                    salary.employee.employeePension
                                      ? salary.employee.employeePension
                                          .pensionNo
                                      : ""
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="display: flex; flex-wrap: wrap; margin-bottom: 5px !important;">
                    <div
                      style="
                        padding: 0 !important;
                        margin-right: 1% !important;
                        margin-top: 1rem !important;
                        margin-left: 0 !important;
                        max-width: 49.5%;
                        flex: 0 0 50%;
                        margin-bottom: 10px !important;
                      "
                    >
                      <table class="table table-border">
                        <thead>
                          <th
                            width="50%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                              font-weight: 600;
                              font-size: larger;
                            "
                          >
                            Emolument
                          </th>
                          <th
                            width="50%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                              font-weight: 600;
                              font-size: larger;
                            "
                          >
                            Amount
                          </th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in salary.data.emolument"
                            :key="item.label"
                          >
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              {{ item.label }}
                            </td>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              {{
                                item.value
                                  ? item.value
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>Total Earning</strong>
                            </td>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>{{
                                salary.data.totalEmolument
                                  ? salary.data.totalEmolument
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div
                      class="col-lg-6 m-b-20"
                      style="
                        padding: 0 !important;
                        margin-right: 0 !important;
                        margin-top: 1rem !important;
                        margin-left: 0 !important;
                        max-width: 49.5%;
                        flex: 0 0 50%;
                        margin-bottom: 10px !important;
                      "
                    >
                      <table class="table table-border">
                        <thead>
                          <th
                            width="50%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              
                              padding-bottom: 0 !important;
                              font-weight: 600;
                              font-size: larger;
                            "
                          >
                            Deduction
                          </th>
                          <th
                            width="50%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                              font-weight: 600;
                              font-size: larger;
                            "
                          >
                            Amount
                          </th>
                        </thead>
                        <tbody>
                          <tr
                            v-for="item in salary.data.deduction"
                            :key="item.label"
                          >
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              {{ item.label }}
                            </td>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              {{
                                item.value
                                  ? item.value
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>Total Deduction</strong>
                            </td>
                            <td
                              width="50%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>{{
                                salary.data.totalDeduction
                                  ? salary.data.totalDeduction
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div style="display: flex; flex-wrap: wrap;">
                    <div
                      style="
                        padding: 0 !important;
                        margin-left: 0 !important;
                        max-width: 100%;
                        flex: 0 0 100%;
                      "
                    >
                      <h3>Summary of Payments</h3>
                      <table class="table table-border">
                        <thead>
                          <th
                            width="33.33%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                            "
                          >
                            <strong>Total Earning</strong>
                          </th>
                          <th
                            width="33.33%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                            "
                          >
                            <strong>Total Deduction</strong>
                          </th>
                          <th
                            width="33.33%"
                            style="
                              padding-left: 10px !important;
                              padding-top: 0 !important;
                              padding-bottom: 0 !important;
                            "
                          >
                            <strong>Net Pay</strong>
                          </th>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              width="33.33%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>{{
                                salary.data.totalEmolument
                                  ? salary.data.totalEmolument
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}</strong>
                            </td>
                            <td
                              width="33.33%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>{{
                                salary.data.totalDeduction
                                  ? salary.data.totalDeduction
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}</strong>
                            </td>
                            <td
                              width="33.33%"
                              style="
                                padding-left: 10px !important;
                                padding-top: 0 !important;
                                padding-bottom: 0 !important;
                              "
                            >
                              <strong>{{
                                salary.data.net
                                  ? salary.data.net
                                      .toString()
                                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                                  : 0
                              }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/employeeSidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";
import html2pdf from "html2pdf.js";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      th_val: ["", "thousand", "million", "billion", "trillion"],
      dg_val: [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine"
      ],
      tn_val: [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen"
      ],
      tw_val: [
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety"
      ],
      id: this.$route.params.id,
      salary: {
        employee: {
          destination: {
            designation: {}
          },
          employeeBank: {}
        },
        data: {}
      },
      logo: "",
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      printObj: {
        id: "printMe",
        preview: false,
        previewTitle: "print Pay slip", // The title of the preview window. The default is 打印预览
        popTitle: "good print",
        // extraCss: "https://cdn.jsdelivr.net/npm/bootstrap@4.6.1/dist/css/bootstrap.min.css",
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        previewBeforeOpenCallback(vue) {
          console.log("正在加载预览窗口");
        },
        previewOpenCallback(vue) {
          console.log("已经加载完预览窗口");
        },
        beforeOpenCallback(vue) {
          vue.printLoading = true;
          console.log("打开之前");
        },
        openCallback(vue) {
          vue.printLoading = false;
          console.log("执行了打印");
        },
        closeCallback(vue) {
          console.log("关闭了打印工具");
        }
      }
    };
  },
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
    this.getOrg();
    this.getPayslip();
  },
  methods: {
    exportToPdf() {
      html2pdf(this.$refs.document);
    },
    print() {
      this.$htmlToPaper("printMe");
    },
    getPayslip() {
      const period = this.id;
      paymentService.getPayslip(period).then(
        async model => {
          var elements = await paymentService.getSalaryElements(
            this.company.id
          );
          // console.log(model);
          this.salary.employee = model.employee;

          let emoluments = [];
          let deductions = [];
          let emol = elements.filter(c => c.categoryId == 1 && c.showInPayslip);
          let dedu = elements.filter(c => c.categoryId == 2 && c.showInPayslip);
          let relief = elements.filter(
            c => c.categoryId == 3 && c.showInPayslip
          );

          for (var i = 0; i < emol.length; i++) {
            var objName = emol[i].column.toLowerCase();
            var data = model[objName];

            if (data > 0) {
              emoluments.push({
                label: emol[i].description,
                value: data.toFixed(2)
              });
            }
          }

          for (var i = 0; i < dedu.length; i++) {
            var objName = dedu[i].column.toLowerCase();
            var data = model[objName];

            if (data > 0) {
              deductions.push({
                label: dedu[i].description,
                value: data.toFixed(2)
              });
            }
          }

          for (var i = 0; i < relief.length; i++) {
            var objName = relief[i].column.toLowerCase();
            var data = model[objName];

            if (data > 0) {
              emoluments.push({
                label: relief[i].description,
                value: data.toFixed(2)
              });
            }
          }

          this.salary.data = {
            emolument: emoluments,
            deduction: deductions,
            totalEmolument: (model.earnings + model.reliefs).toFixed(2),
            totalDeduction: model.deductions.toFixed(2),
            net: model.netSalary.toFixed(2),
            periodMonth: model.periodMonth,
            periodYear: model.periodYear
          };
          console.log(this.salary);
        },
        error => {
          error = error;
        }
      );
    },

    getOrg() {
      organizationService.getOrganization().then(o => {
        this.theme = o.theme;
        this.logo = o.logo;
      });
    },

    toWordsconvert(s) {
      s = s.toString();
      s = s.replace(/[\, ]/g, "");
      if (s != parseFloat(s)) return "not a number ";
      var x_val = s.indexOf(".");
      if (x_val == -1) x_val = s.length;
      if (x_val > 15) return "too big";
      var n_val = s.split("");
      var str_val = "";
      var sk_val = 0;
      for (var i = 0; i < x_val; i++) {
        if ((x_val - i) % 3 == 2) {
          if (n_val[i] == "1") {
            str_val += this.tn_val[Number(n_val[i + 1])] + " ";
            i++;
            sk_val = 1;
          } else if (n_val[i] != 0) {
            str_val += this.tw_val[n_val[i] - 2] + " ";
            sk_val = 1;
          }
        } else if (n_val[i] != 0) {
          str_val += this.dg_val[n_val[i]] + " ";
          if ((x_val - i) % 3 == 0) str_val += "hundred, ";
          sk_val = 1;
        }
        if ((x_val - i) % 3 == 1) {
          if (sk_val)
            str_val +=
              this.th_val[(x_val - i - 1) / 3] + ((x_val - i - 1) / 3 == 0)
                ? ""
                : ", ";
          sk_val = 0;
        }
      }
      if (x_val != s.length) {
        var y_val = s.length;
        str_val += "point ";
        for (var i = x_val + 1; i < y_val; i++)
          str_val += this.dg_val[n_val[i]] + " ";
      }
      str_val += "only.";
      return str_val.replace(/\s+/g, " ");
    }
  },
  name: "salaryview"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryviewHR.vue